import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
//import { LocalApiConnectorService } from '../../../../services/local-api-connector.service';
import { ConfigService } from '../../../../services/endpoint.config.service';
declare let $: any;
@Component({
  selector: 'app-commercial-invoice',
  templateUrl: './commercial-invoice.component.html',
  styleUrls: ['./commercial-invoice.component.scss']
})
export class CommercialInvoiceComponent implements OnInit {

  constructor(//private agent: LocalApiConnectorService,
              private _sanitizer: DomSanitizer,
              private configs: ConfigService) { }
  @Input() lock = false;
  @Output() close = new EventEmitter()
  @Input() scanners: any[] = []
  @Input() shipmentAttachment;
  @Output() onAddShipmentAttachment = new EventEmitter();
  sss:any;
  ScannedFile = [] ;
  scanText: string = 'Scan'
  scannerName = -1;
  scannedImage = null as any
 @ViewChild('commercialInvoice') commercialInvoiceButton: ElementRef
  openCommercialInvoiceFile() {

   this.commercialInvoiceButton.nativeElement.click()
  }
  closeRecepit() {
    this.close.emit(true);
  }
  handleImage(e) {
    var file = e.currentTarget.files[0];
    var reader = new FileReader();
    reader.onloadend = () => {
      this.scannedImage = reader.result.toString()
    }
    reader.readAsDataURL(file);
  }
 
  
  // scanIdObj: any = "";
  // scanningTimer: any = null;
  // ScanIdScannerName = "-1";
  // hideLoader = true;
  // scannedImage1 = this._sanitizer.bypassSecurityTrustResourceUrl("");

 scan() {
    var _this = this;
   _this.sss.scan({
		'documentId': 1
   });

   _this.sss.onAfterScan = function(data) {
     console.log(data);
     _this.ScannedFile = _this.ContentOfFile(data);
    }
  }
    // this.hideLoader = false;
    // this.scanText = 'Scanning...';
    // var param = { "ScannerName": this.scannerName };
    // this.agent.startScaning((res) => {
    //   this.scanningTimer = setInterval(() => {
    //     this.agent.getScanningResult((res) => {
    //       if (this.scanIdObj == "") {
    //         this.scanIdObj = res;
    //         this.scannedImage = this.getScanIdImage()
    //         this.hideLoader = true;
    //       }
    //       else {
    //         let dummyClick = document.getElementsByTagName('h4') as any
    //         dummyClick[0].click()
    //         this.scanText = 'Scan';
    //         this.hideLoader = true;
    //         clearInterval(this.scanningTimer);
    //       }
    //     })
    //   }, 1000)

    // }, param);

  ContentOfFile(base64) {
    var Base64 = base64
    // Split the base64 string in data and contentType
    var block = Base64.split(";");
    // Get the content type of the image
    var contentType = block[0].split(":")[1];// In this case "image/gif"
    // get the real base64 content of the file
    var realData = block[1].split(",")[1];// In this case "R0lGODlhPQBEAPeoAJosM...."

    // return real data
    return realData;
  }

  addCommercialInvoice() {
    this.onAddShipmentAttachment.emit(this.ScannedFile);
    this.closeRecepit();
    
  }

  // getScanIdImage() {
  //   var imagePath = this._sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + this.scanIdObj.Result);
  //   return imagePath;
  // }

  ngOnInit() {
    this.sss = $("#dvamxscan").amxScanMngr('992ada1b68b34b618173a221393ba8ce',this.configs.getEnviromentId());
    this.sss.start();
    this.sss.result = function (e) {
		  var y = e;
	  };   
  }

  webcamCapturedImage: string | null = null;
  showWebcamModal: boolean = false;

  handleWebcamCapturedImage(base64Image) {
    this.webcamCapturedImage = base64Image;

    this.ScannedFile = this.ContentOfFile(base64Image);
  }

}
